export const formatToHTML = (value: string) => {
  const newValue = value
    .replaceAll(/(?:\*\*)([^*]*)(?:\*\*)/g, '<strong>$1</strong>')
    .replaceAll(/(?:__)([^_]*)(?:__)/g, '<i>$1</i>')
  return newValue
}

export const useDangerousHTML = (value: string) => ({
  __html: formatToHTML(value)
})
